<template>
    <div>
        <div class="novaCategoria">
            <a @click="$router.go(-1)">{{'<< Voltar'}}</a><br>
            <router-link :to="{ name: 'Nova Categoria', params: { tipo: 'servico' } }" ><button class="btn btn-primary">Nova Categoria (serviço)</button></router-link>
        </div>
        <div class="tableProd">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Nome</th>
                        <th scope="col">Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="categoria in categorias">
                        <th scope="row">{{categoria.id}}</th>
                        <td>{{categoria.nome}}</td>
                        <td class="row">
                            <div class="col-sm-2"><a @click="editar(categoria.id)"><i class="glyphicon glyphicon-pencil padding"></i></a></div>
                            <div class="col-sm-2"><a @click="confirmDelete(categoria.id)"><i class="glyphicon glyphicon-trash"></i></a></div>
                        </td>

                    </tr>
                </tbody>
            </table>
        </div>

        <modal v-if="showModal" @close="showModal = false" @confirm="deletar">
            <h3 slot="header">Deseja realmente deletar?</h3>
        </modal>
    </div>
</template>
<script>
import firebase from 'firebase';
import Modal from '../components/Modal';

export default {
    name: 'Categorias Serv Admin',
	data() {
		return {
            categorias: [],
            showModal: false,
            idExcluir: null
		}
    },
    components: {
        Modal
    },
	created() {
		// this.searchText = this.$route.params.searchText ? this.$route.params.searchText : ''
		this.getCategoria();
	},
	methods: {
		getCategoria() {
			var cat = firebase.database().ref('categorias/')
			cat.on('child_added', (data) => {
				this.categorias.push({ nome: data.val().nome, id: data.key})
			});
        },
        editar(id) {
			this.$router.push({name: 'Nova Categoria', params: { id : id, tipo: 'produto' } })
        },
        confirmDelete(id) {
            this.showModal = true;
            this.idExcluir = id;
        },
        async deletar() {
            // alert()
            await firebase.database().ref('categorias/' + this.idExcluir).remove()
            this.$router.go()
        }
	}
}
</script>
<style>
.novaCategoria{
    padding-top: 40px;
    padding-bottom: 40px;
    text-align: left
}
.padding{
    padding-right: 10px
}
</style>
